/*
 * @Description:
 * @Autor: yangx
 * @Date: 2025-10-15 09:21:01
 */
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import { default as webRouter } from '@/modules/workOnline/router'
import { default as mobileRouter } from '@/modules/officialAccounts/router'
import { Dialog, Notify } from 'vant'
import theme from '@/styles/theme.scss'

const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'

const service = axios.create({
  baseURL: projectConfig.baseURL,
  timeout: 20000
})

service.interceptors.request.use(
  config => {
    const expireTime = localStorage.getItem('expireTime')
    if (expireTime) {
      const currentTime = new Date().getTime()
      const timeDiff = (expireTime - currentTime) / 1000 / 60 // 分钟
      if (timeDiff > 0 && timeDiff < 20) {
        axios.get(projectConfig.baseURL + '/bd/user/refreshToken', {
          headers: { 'token': localStorage.getItem('sys_token') }
        }).then(res => {
          const { token, expireTime } = res.data.data
          localStorage.setItem('sys_token', token)
          localStorage.setItem('expireTime', expireTime)
        })
      }
    }
    config.headers.token = localStorage.getItem('sys_token')
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(response => {
  const res = response.data
  if (res.code && res.code !== 2000 && res.code !== 200) {
    switch (res.code) {
      case 4010:
        localStorage.clear()
        if (isMobile) {
          Dialog.alert({
            title: '温馨提示',
            message: '您的登录信息已过期，请重新登录！',
            confirmButtonText: '去登录',
            confirmButtonColor: theme.mainColor
          }).then(() => {
            window.location.href = projectConfig.jumpURL + '/mobile/'
            // mobileRouter.push('/login') // 移动端首页本地调试
          })
        } else {
          MessageBox.alert('您的登录信息已过期，请重新登录！', '温馨提示', {
            confirmButtonText: '去登录',
            showClose: false,
            type: 'warning',
          }).then(() => {
            window.location.href = projectConfig.jumpURL
            // webRouter.push('/login') // PC端首页本地调试
          })
        }
        break
      default:
        if (isMobile) {
          return Promise.reject(Notify({
            message: res.message || res.msg,
            type: 'warning',
          }))
        } else {
          return Promise.reject(Message({
            message: res.message || res.msg,
            type: 'warning',
          }))
        }
    }
  } else {
    return res
  }
}, error => {
  if (isMobile) {
    return Promise.reject(Notify({
      message: '请求超时，请检查网络状况',
      type: 'warning',
    }))
  } else {
    return Promise.reject(Message({
      message: '请求超时，请检查网络状况',
      type: 'warning',
    }))
  }
})

export default service